import toast from "react-hot-toast";

(() => {
  const linkShare = document.querySelectorAll(".js-link-share");

  linkShare.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const { copy } = link.dataset;

      navigator.clipboard.writeText(window.location.href).then(() => {
        toast.success(copy, {
          duration: 2000,
          style: {
            fontSize: "1.2rem",
          },
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        });
      });
    });
  });
})();
